// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610020134/js/" + chunkId + "." + {"44":"fc15f7e1","225":"fc2734be","481":"d34c8903","486":"b5acb23f","770":"556b272e"}[chunkId] + ".0.5982309424251503.chunk.js";
};